'use client'

export default function LandingBlockExplainSimpler(props: any) {
    return (
        <div style={{maxWidth: 600}} className={"px-4 lg:px-0"}>
            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                <span className={"text-4xl font-semibold"}>{`Explain simpler!`}</span>
                <div className={"border-b border-b-fuchsia-400 w-10 md:w-20 lg:w-96 my-7"}></div>
            </div>
            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                We scan hundreds of thousands of options
                <br/>
                available at this moment.
            </div>
            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                We remove the 💩 bad trades.
                <div className={"text-sm text-gray-500 mt-2"}>
                    Low risk to reward ratio? Gone. Low credit? High debit? Gone.
                    Low probability of success? Gone.
                </div>
            </div>
            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                You get the 💎 awesome ones.
            </div>
            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                You automate your options search.
                <br/>
                Increase your profit probability. And overall profit.
            </div>
        </div>
    )
}
